import React from 'react';
import { Route, Redirect, RouteProps, RouteComponentProps } from 'react-router-dom';
import UserContext from 'react-scale/components/ui/UserContext';
import Loading from 'react-scale/components/legacy-css/loading';
import { useUser } from './useUser';

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType;
}

export default function PrivateRoute({ component, ...rest }: PrivateRouteProps) {
  return (
    <Route {...rest} render={props => <PrivateRouteComponent component={component} {...props} />} />
  );
}

interface PrivateRouteComponentProps extends RouteComponentProps {
  component: React.ComponentType;
}

function PrivateRouteComponent({ component: Component, location }: PrivateRouteComponentProps) {
  const { user, isLoading, isError } = useUser();

  if (isLoading) return <Loading />;
  if (isError)
    return (
      <Redirect
        to={{
          pathname: '/login',
          search: new URLSearchParams({ redirect_url: location.pathname }).toString(),
        }}
      />
    );

  return (
    <UserContext.Provider value={user}>
      <Component />
    </UserContext.Provider>
  );
}
